const API_IMOVIE = process.env.API_IMOVIE;
/* const API_IMOVIE = 'http://192.168.100.43:8082' */
var Base = {
  //  兼容http/https协议
  httpOrHttps: {
    httpOrHttps: () => {
      if (process.env.NODE_ENV === "development") {
        return ""
      } else {
        return window.location.protocol === "https:" ? "https://" : "http://"
      }
    }
  },
  common:{
    adywAuth: () => {
      return `${API_IMOVIE}/m/wechatMpAuth/adywAuth`
    },
    ayyAuth: () => {
      return `${API_IMOVIE}/m/wechatMpAuth/ayyAuth`
    },
    bindWechat: () => {
      return `${API_IMOVIE}/m/sys/bindWechat`
    }
  },
  wechat:{
    adywJsSdk: () => {
      return `${API_IMOVIE}/m/wechatMpJsSdk/adywJsSdk`
    }
  },
  public:{
    //上传图片
    uploadImage:() => {
      return `${API_IMOVIE}/fileUpload/uploadImage`
    },
    //获取短信接口
    sendValidCode:() => {
      return `${API_IMOVIE}/sms/sendValidCode`
    },
  },
  gzh:{
    verificationShopOrder: () => {
      return `${API_IMOVIE}/m/shopOrder/verificationShopOrder`
    },
    cancelAfterPhysicalCoupon: () => {
      return `${API_IMOVIE}/m/coupon/cancelAfterPhysicalCoupon`
    },
    qryPhysicalCoupon: () => {
      return `${API_IMOVIE}/m/coupon/qryPhysicalCoupon`
    },
    qryShopOrder: () => {
      return `${API_IMOVIE}/m/shopOrder/qryShopOrder`
    }
  },
  bill:{
    //查询影院账单信息接口 
    billQuery: () => {
      return `${API_IMOVIE}/m/cinemaSill/query`
    },
    //影院月度账单确认接口
    billConfirm: () => {
      return `${API_IMOVIE}/m/cinemaSill/confirm`
    }
  },
  studio: { 
    //查询物料任务列表
    qryMaterielTaskList: () => {
      return `${API_IMOVIE}/m/materielTaskPublish/qryMaterielTaskList`
    },
    //新建/编辑物料任务
    saveMaterielTask: () => {
      return `${API_IMOVIE}/m/materielTaskPublish/saveMaterielTask`
    },
    //根据id查询物料任务
    qryMaterielTaskById: () => {
      return `${API_IMOVIE}/m/materielTaskPublish/qryMaterielTaskById`
    },
    //发布任务
    releaseMaterielTask: () => {
      return `${API_IMOVIE}/m/materielTaskPublish/releaseMaterielTask`
    },
    //删除任务
    deleteMaterielTask: () => {
      return `${API_IMOVIE}/m/materielTaskPublish/deleteMaterielTask`
    },
    //查询物料任务领取详情分页
    qryMaterielTaskDetailPage: () => {
      return `${API_IMOVIE}/m/materielTaskPublish/qryMaterielTaskDetailPage`
    },
    //物料任务审核详情
    materielTaskAuditDetail: () => {
      return `${API_IMOVIE}/m/materielTaskPublish/materielTaskAuditDetail`
    },
    //报名审核 
    enrollAudit: () => {
      return `${API_IMOVIE}/m/materielTaskPublish/enrollAudit`
    },
    //物料审核
    materielAudit: () => {
      return `${API_IMOVIE}/m/materielTaskPublish/materielAudit`
    },

    //转发任务_查询任务列表分页接口  
    queryForwardTaskPage: () => {
      return `${API_IMOVIE}/m/forwardTaskPublish/queryForwardTaskPage`
    },
    //转发任务_查看任务详情接口
    queryForwardTaskDetail: () => {
      return `${API_IMOVIE}/m/forwardTaskPublish/queryForwardTaskDetail`
    },
    //转发任务_查询任务领取列表分页接口
    queryForwardTaskDetailPage: () => {
      return `${API_IMOVIE}/m/forwardTaskPublish/queryForwardTaskDetailPage`
    },
    //转发任务_查看任务领取详情接口 
    queryForwardTaskReceiveDetail: () => {
      return `${API_IMOVIE}/m/forwardTaskPublish/queryForwardTaskReceiveDetail`
    },
    //转发任务_审核报名接口 
    auditEnrollTask:() => {
      return `${API_IMOVIE}/m/forwardTaskPublish/auditEnrollTask`
    },
    //转发任务_审核转发接口
    auditForwardTask:() => {
      return `${API_IMOVIE}/m/forwardTaskPublish/auditForwardTask`
    },
    //保存
    saveForwardTasks:() => {
      return `${API_IMOVIE}/m/forwardTaskPublish/saveForwardTasks`
    },
    qryAreaLabelList:() => {
      return `${API_IMOVIE}/m/areaLabel/qryAreaLabelList`
    },
    //新建标签
    saveAreaLabel:() => {
      return `${API_IMOVIE}/m/areaLabel/saveAreaLabel`
    },
    //编辑标签
    editAreaLabel:() => {
      return `${API_IMOVIE}/m/areaLabel/editAreaLabel`
    },
    //查询城市
    queryCityList:() => {
      return `${API_IMOVIE}/m/areaLabel/queryCityList`
    },
    //保存城市
    saveAreaLabelCity:() => {
      return `${API_IMOVIE}/m/areaLabel/saveAreaLabelCity`
    },
    //获取片方用户信息
    queryUserInfo:() => {
      return `${API_IMOVIE}/m/publishInfo/query`
    },
    //完善片方用户信息
    userPerfect:() => {
      return `${API_IMOVIE}/m/publishInfo/perfect`
    },
    rechargeRecord:() => {
      return `${API_IMOVIE}/m/publishInfo/rechargeRecord`
    },
    consumeRecord:() => {
      return `${API_IMOVIE}/m/publishInfo/consumeRecord`
    },
    qryShowTaskList:() => {
      return `${API_IMOVIE}/m/showTaskPublish/qryShowTaskList`
    },
    saveShowTask:() => {
      return `${API_IMOVIE}/m/showTaskPublish/saveShowTask`
    },
    qryFilmList:() => {
      return `${API_IMOVIE}/m/showTaskPublish/qryFilmList`
    },
    qryShowTaskById:() =>{
      return `${API_IMOVIE}/m/showTaskPublish/qryShowTaskById`
    },
    editShowTask:() =>{
      return `${API_IMOVIE}/m/showTaskPublish/editShowTask`
    },
    qryShowTaskDetail:() =>{
      return `${API_IMOVIE}/m/showTaskPublish/qryShowTaskDetail`
    },
    qryShowTaskDetailPage:() =>{
      return `${API_IMOVIE}/m/showTaskPublish/qryShowTaskDetailPage`
    },
    releaseShowTask:() =>{
      return `${API_IMOVIE}/m/showTaskPublish/releaseShowTask`
    },
    publishForwardTasks:() =>{
      return `${API_IMOVIE}/m/forwardTaskPublish/publishForwardTasks`
    },
    deleteShowTask:() =>{
      return `${API_IMOVIE}/m/forwardTaskPublish/deleteShowTask`
    },
  },
  cinema:{
     //查询发放任务列表
    qryPendingMaterielTaskList: () => {
      return `${API_IMOVIE}/m/materielTaskCinema/qryPendingMaterielTaskList`
    },
    //查询任务详情
    qryMaterielTaskDetail: () => {
      return `${API_IMOVIE}/m/materielTaskCinema/qryMaterielTaskDetail`
    },
    //任务报名
    materielTaskEnroll: () => {
      return `${API_IMOVIE}/m/materielTaskCinema/materielTaskEnroll`
    },
    //查询已领任务列表
    qryReceivedMaterielTaskList: () => {
      return `${API_IMOVIE}/m/materielTaskCinema/qryReceivedMaterielTaskList`
    },
    //已领任务详情
    receivedMaterielTaskDetail: () => {
      return `${API_IMOVIE}/m/materielTaskCinema/receivedMaterielTaskDetail`
    },
    //提交审核
    materielTaskSubmitAudit: () => {
      return `${API_IMOVIE}/m/materielTaskCinema/materielTaskSubmitAudit`
    },
    //转发任务_报名接口 
    enrollForwardTask: () => {
      return `${API_IMOVIE}/m/forwardTaskCinema/enrollForwardTask`
    },
    //转发任务_全部任务列表分页接口 
    queryAllForwardTaskPage: () => {
      return `${API_IMOVIE}/m/forwardTaskCinema/queryAllForwardTaskPage`
    },
    //转发任务_查看我的任务详情接口  
    queryOwnForwardTaskReceive: () => {
      return `${API_IMOVIE}/m/forwardTaskCinema/queryOwnForwardTaskReceive`
    },
    //转发任务_我的任务列表分页接口
    queryOwnForwardTaskReceivePage: () => {
      return `${API_IMOVIE}/m/forwardTaskCinema/queryOwnForwardTaskReceivePage`
    },
    //转发任务_上传接口
    uploadForwardTask: () => {
      return `${API_IMOVIE}/m/forwardTaskCinema/uploadForwardTask`
    },
    
    //查询影院方个人信息接口 
    queryCinemaInfo: () => {
      return `${API_IMOVIE}/m/cinemaInfo/query`
    },
    //合作影院信息校验接口
    valid: () => {
      return `${API_IMOVIE}/m/cinemaInfo/valid`
    },
    // 完善影院信息接口
    perfectCinemaInfo: () => {
      return `${API_IMOVIE}/m/cinemaInfo/perfectCinemaInfo`
    },
    // 完善公众号信息接口
    perfectWechatInfo: () => {
      return `${API_IMOVIE}/m/cinemaInfo/perfectWechatInfo`
    },
    //.查询影院方收入明细接口
    incomeDetail: () => {
      return `${API_IMOVIE}/m/cinemaInfo/incomeDetail`
    },

    //查询发放任务列表
    qryPendingShowTaskList: () => {
      return `${API_IMOVIE}/m/showTaskCinema/qryPendingShowTaskList`
    },
    //查询任务详情 
    qryShowTaskDetail: () => {
      return `${API_IMOVIE}/m/showTaskCinema/qryShowTaskDetai`
    },
    //任务报名
    showTaskEnroll: () => {
      return `${API_IMOVIE}/m/showTaskCinema/showTaskEnroll`
    },
    //查询已领任务列表
    qryReceivedShowTaskList: () => {
      return `${API_IMOVIE}/m/showTaskCinema/qryReceivedShowTaskList`
    },
    //任务进度详情
    qryShowTaskProgressDetail: () => {
      return `${API_IMOVIE}/m/showTaskCinema/qryShowTaskProgressDetail`
    }
  },
  filmInvest:{
    projectList: () => {
      return `${API_IMOVIE}/m/filmInvest/projectList`
    },
    projectDetail: () => {
      return `${API_IMOVIE}/m/filmInvest/projectDetail`
    },
    sendProjectData: () => {
      return `${API_IMOVIE}/m/filmInvest/sendProjectData`
    },
    savePrimaryResult: () => {
      return `${API_IMOVIE}/m/filmInvest/savePrimaryResult`
    },
    saveRecheckResult: () => {
      return `${API_IMOVIE}/m/filmInvest/saveRecheckResult`
    },
    saveSignResult: () => {
      return `${API_IMOVIE}/m/filmInvest/saveSignResult`
    },
    findScoreDetail: () => {
      return `${API_IMOVIE}/m/filmInvestProjectScore/findScoreDetail`
    },
    submitScoreDetail: () => {
      return `${API_IMOVIE}/m/filmInvestProjectScore/submitScoreDetail`
    },
    findScorePage: () => {
      return `${API_IMOVIE}/m/filmInvestProjectScore/findScorePage`
    },
    findScoreDetailView: () => {
      return `${API_IMOVIE}/m/filmInvestProjectScore/findScoreDetailView`
    },
    qryProgressList: () => {
      return `${API_IMOVIE}/m/filmInvest/qryProgressList`
    },
    saveProjectProgress: () => {
      return `${API_IMOVIE}/m/filmInvest/saveProjectProgress`
    },
    saveProjectProgressComment: () => {
      return `${API_IMOVIE}/m/filmInvest/saveProjectProgressComment`
    },
    findProjectDataPage: () => {
      return `${API_IMOVIE}/m/filmInvestProjectScore/findProjectDataPage`
    },
    qryRecheckProject: () => {
      return `${API_IMOVIE}/m/filmInvest/qryRecheckProject`
    },
    contractList: () => {
      return `${API_IMOVIE}/m/filmInvestContract/contractList`
    },
    finishContract: () => {
      return `${API_IMOVIE}/m/filmInvestContract/finishContract`
    },
    projectContractList: () => {
      return `${API_IMOVIE}/m/filmInvestContract/projectContractList`
    },
    contractDetail: () => {
      return `${API_IMOVIE}/m/filmInvestContract/contractDetail`
    },
    qryContractPaymentRecord: () => {
      return `${API_IMOVIE}/m/filmInvestContract/qryContractPaymentRecord`
    },
    qryFilmProgress: () => {
      return `${API_IMOVIE}/m/filmInvestContract/qryFilmProgress`
    },
    qryContractIncomeRecord: () => {
      return `${API_IMOVIE}/m/filmInvestContract/qryContractIncomeRecord`
    },
    changeToNegotiate: () => {
      return `${API_IMOVIE}/m/filmInvestContract/changeToNegotiate`
    },
    contractFinishIncome: () => {
      return `${API_IMOVIE}/m/filmInvestContract/contractFinishIncome`
    },
    contractFinishPaymen: () => {
      return `${API_IMOVIE}/m/filmInvestContract/contractFinishPayment`
    },
    qryContractConsultRecord: () => {
      return `${API_IMOVIE}/m/filmInvestContract/qryContractConsultRecord`
    },
    changeToNegotiateFinish: () => {
      return `${API_IMOVIE}/m/filmInvestContract/changeToNegotiateFinish`
    },
    changeToLawsuit: () => {
      return `${API_IMOVIE}/m/filmInvestContract/changeToLawsuit`
    },
    changeToArbitrate: () => {
      return `${API_IMOVIE}/m/filmInvestContract/changeToArbitrate`
    },
    qryNoReportContract: () => {
      return `${API_IMOVIE}/m/filmInvestContract/qryNoReportContract`
    },
    reportListByMobile: () => {
      return `${API_IMOVIE}/m/filmInvestReport/reportListByMobile`
    },
    saveReportByMobile: () => {
      return `${API_IMOVIE}/m/filmInvestReport/saveReportByMobile`
    },
    qryReportDetail: () => {
      return `${API_IMOVIE}/m/filmInvestReport/qryReportDetail`
    },
    saveReportLinkupByMobile: () => {
      return `${API_IMOVIE}/m/filmInvestReport/saveReportLinkupByMobile`
    },
    saveReportLinkupComment: () => {
      return `${API_IMOVIE}/m/filmInvestReport/saveReportLinkupComment`
    },
    consumerList: () => {
      return `${API_IMOVIE}/m/filmInvestConsumer/consumerList`
    },
    qryArbitrateDetail: () => {
      return `${API_IMOVIE}/m/contractArbitrate/qryArbitrateDetail`
    },
    qryArbitrateExecute: () => {
      return `${API_IMOVIE}/m/contractArbitrate/qryArbitrateExecute`
    },
    arbitrateFinish: () => {
      return `${API_IMOVIE}/m/contractArbitrate/arbitrateFinish`
    },
    executeFinish: () => {
      return `${API_IMOVIE}/m/contractArbitrate/executeFinish`
    },
    qryArbitrateExecuteRecord: () => {
      return `${API_IMOVIE}/m/contractArbitrate/qryExecuteRecord`
    },
    qryLawsuitDetail: () => {
      return `${API_IMOVIE}/m/contractLawsuit/qryLawsuitDetail`
    },
    goToMediate: () => {
      return `${API_IMOVIE}/m/contractLawsuit/goToMediate`
    },
    cancelProsecute: () => {
      return `${API_IMOVIE}/m/contractLawsuit/cancelProsecute`
    },
    updateLawsuitState: () => {
      return `${API_IMOVIE}/m/contractLawsuit/updateLawsuitState`
    },
    qryExecuteRecord: () => {
      return `${API_IMOVIE}/m/contractLawsuit/qryExecuteRecord`
    },
    writeAskAdviceResultByMobile: () => {
      return `${API_IMOVIE}/m/filmInvestProjectAskAdvice/writeAskAdviceResultByMobile`
    },
    saveAskAdviceResultByMobile: () => {
      return `${API_IMOVIE}m/filmInvestProjectAskAdvice/saveAskAdviceResultByMobile`
    },
    qryMeetingVerify: () => {
      return `${API_IMOVIE}/m/filmInvest/qryMeetingVerify`
    },
    saveMeetingVerify: () => {
      return `${API_IMOVIE}/m/filmInvest/saveMeetingVerify`
    },
    qryMettingDetail: () => {
      return `${API_IMOVIE}/m/filmInvest/qryMettingDetail`
    },
    qryLawsuitFirst: () => {
      return `${API_IMOVIE}/m/contractLawsuit/qryLawsuitFirst` 
    },
    qrySignNoContractProject: () => {
      return `${API_IMOVIE}/m/filmInvest/qrySignNoContractProject` 
    },
    qryFilmInfoList: () => {
      return `${API_IMOVIE}/m/filmInvestFilmResource/qryFilmInfoList` 
    },
    qryFilmInfoDetail: () => {
      return `${API_IMOVIE}/m/filmInvestFilmResource/qryFilmInfoDetail` 
    },
    qryCelebrityInfoList: () => {
      return `${API_IMOVIE}/m/filmInvestFilmResource/qryCelebrityInfoList` 
    },
    qryCelebrityInfoDetail: () => {
      return `${API_IMOVIE}/m/filmInvestFilmResource/qryCelebrityInfoDetail` 
    },
    qryCompanyInfoList: () => {
      return `${API_IMOVIE}/m/filmInvestFilmResource/qryCompanyInfoList` 
    },
    qryCompanyInfoDetail: () => {
      return `${API_IMOVIE}/m/filmInvestFilmResource/qryCompanyInfoDetail` 
    },
    qrySubContractList: () => {
      return `${API_IMOVIE}/m/filmInvestContract/qrySubContractList` 
    },
    qryContractFundsCase: () => {
      return `${API_IMOVIE}/m/filmInvestContract/qryContractFundsCase` 
    },
    qryCompany: () => {
      return `${API_IMOVIE}/m/filmInvestConsumer/qryCompany` 
    },
  }
}
module.exports = Base



// WEBPACK FOOTER //
// ./src/network/Address.js